const IDLE_TIMEOUT = 15 * 60 * 1000;
const ABSOLUTE_TIMEOUT = 8 * 60 * 60 * 1000;

export const sessionWatcher = {
    store: null,
    idleTimer: null,
    absoluteTimer: null,

    lastActivityTime: 0,
    THROTTLE_DELAY: 2000,

    start(storeInstance) {
        this.store = storeInstance;
        this.checkAbsoluteTimeout();
        this.resetIdleTimer();
        this.attachListeners();
    },

    stop() {
        clearTimeout(this.idleTimer);
        clearTimeout(this.absoluteTimer);
        this.removeListeners();
        this.store = null;
    },

    checkAbsoluteTimeout() {
        const loginTime = parseInt(localStorage.getItem('loginTimestamp'), 10);

        if (!loginTime) {
            return;
        }

        const now = Date.now();
        const timeLeft = ABSOLUTE_TIMEOUT - (now - loginTime);

        if (timeLeft <= 0) {
            console.log('Session expired (Absolute limit)');
            this.logout();
        } else {
            this.absoluteTimer = setTimeout(() => {
                console.log('Session time limit reached');
                this.logout();
            }, timeLeft);
        }
    },

    resetIdleTimer() {
        if (this.idleTimer) clearTimeout(this.idleTimer);
        this.idleTimer = setTimeout(() => {
            console.log('User is inactive');
            this.logout();
        }, IDLE_TIMEOUT);
    },

    logout() {
        if (this.store && this.store.auth) {
            this.store.auth.unauthorize();
        }
    },

    handleUserActivity() {
        const now = Date.now();

        if (now - this.lastActivityTime < this.THROTTLE_DELAY) {
            return;
        }

        this.lastActivityTime = now;
        this.resetIdleTimer();
    },

    attachListeners() {
        this.boundHandler = this.handleUserActivity.bind(this);

        window.addEventListener('mousemove', this.boundHandler);
        window.addEventListener('click', this.boundHandler);
        window.addEventListener('keydown', this.boundHandler);
        window.addEventListener('scroll', this.boundHandler);
    },

    removeListeners() {
        if (this.boundHandler) {
            window.removeEventListener('mousemove', this.boundHandler);
            window.removeEventListener('click', this.boundHandler);
            window.removeEventListener('keydown', this.boundHandler);
            window.removeEventListener('scroll', this.boundHandler);
        }
    }
};